import React, { useState } from "react";
import { imageurl, projectNo } from "../../../../_config";
import DataTable from 'react-data-table-component';
import { resizeImage } from "../../../../_services/resizeImage";
import toast from "react-hot-toast";

const SingleProductImages = (props) => {
    const [alignImageData, setAlignImageData] = useState('Vertical');
    const { bulkPopupClose, bulkPopupSkuId, onAddImage, setBulkImageFormData, onBulkUpload, productImageByProductId, fileInputRef, onReset, loading, isHeaderProductImageById, isDisplayProductImageById, isImageFormopen, imageFormData, setIsImageFormopen, setImageFormData, handleImageSubmit, productImageDelete, productDetailByIdData, productImageId, setProductImageId } = props;

    const handleFileChange = async (e) => {
        const { files, name, value, type, checked } = e.target;
    
        if (files && files.length > 0) {
            const validImageTypes = ['image/jpeg', 'image/png'];
    
            for (const file of files) {
                if (validImageTypes.includes(file.type)) {
                    try {
                        const resizedFile = await resizeImage(file, 640, 960);
    
                        setBulkImageFormData(prevState => ({
                            ...prevState,
                            files: [...prevState.files, resizedFile],
                        }));
                    } catch (err) {
                        toast.error("Error resizing the image.");
                    }
                } else {
                    toast.error("Only JPEG and PNG images are allowed.");
                }
            }
        } else {
            setBulkImageFormData(prevState => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };    

    const handleImageChange = async (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file' && files[0]) {
            const file = files[0];

            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                const image = new Image();
                image.src = URL.createObjectURL(file);

                image.onload = async () => {

                    try {
                        const resizedFile = await resizeImage(file, 640, 960);
                        setImageFormData((prevState) => ({
                            ...prevState,
                            [name]: resizedFile
                        }));

                    } catch (err) {
                        toast.error('Error resizing the image.');
                    }
                };
            } else {
                toast.error('Only JPEG and PNG images are allowed.');
            }
        } else {
            setImageFormData((prevState) => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const onCloseImageForm = () => {
        onReset();
        setIsImageFormopen(false);
    }

    const onImageEdit = (item) => {
        setProductImageId(item?.productImageId);
        setIsImageFormopen(true);
        setImageFormData({
            ...imageFormData,
            productImageId: item?.productImageId,
            productId: item?.productId,
            imgPath: item?.imgPath,
            file: null,
            isHeader: item?.isHeader,
            isDisplay: item?.isDisplay,
            isActive: item?.isActive
        });
    }

    const toggleAlignImage = (alignment) => {
        setAlignImageData(alignment);
    };

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Image',
            selector: row => row.imgPath ? <img src={`${imageurl}${row?.imgPath}`} alt="" width="50" /> : 'No Image',
            sortable: false,
            width:'150px'
        },
        {
            name: 'isHeader',
            selector: row => (
                <button
                    onClick={() => isHeaderProductImageById(row)}
                    className={`${row.isHeader ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isHeader ? "TRUE" : "FALSE"}
                </button>
            ),
            sortable: false
        },
        {
            name: 'isDisplay',
            selector: row => (
                <span
                    onClick={() => isDisplayProductImageById(row?.productImageId)}
                    style={{ cursor: 'pointer' }}
                >
                    {row.isDisplay ? (
                        <svg fill="none" height="20" viewBox="0 0 12 12" width="20" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="M0 9h5v2H3v1h6v-1H7v-2h5V0H0z" fill="#526484" stroke="none" />
                            </g>
                        </svg>
                    ) : (
                        <svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="M19 0H1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h5v2h-1c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1h-1v-2h5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-7 18h-4v-2h4zm6-4H2V4h16z" fill="#526484" />
                                <path d="M7.3 10.7c.4.4 1 .4 1.4 0l1.3-1.3 1.3 1.3c.4.4 1 .4 1.4 0s.4-1 0-1.4l-1.3-1.3 1.3-1.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1.3 1.3-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.3 1.3-1.3 1.3c-.4.4-.4 1 0 1.4z" fill="#526484" />
                            </g>
                        </svg>
                    )}
                </span>
            ),
            sortable: false
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title="Edit" onClick={() => onImageEdit(row)} className="edit_icon_wepper">
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title="Delete" onClick={() => productImageDelete(row)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <div>
            <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                <div className="admin-heading" style={{ gap: "20px" }}>
                    <h4 className="mb-0">Product Images</h4>
                </div>
                <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                    <div className="add_btn">
                        <button onClick={onAddImage}>Add Product Image</button>
                    </div>
                </div>
            </div>

            {bulkPopupSkuId && (
                <div className=" mt-3 bulk_image_popup">
                    <div className="bulk_form_wrapper">
                        <div className="closebtn">
                            <button className="" onClick={bulkPopupClose} >
                                <svg clipRule="evenodd" fillRule="evenodd" width="25" height="25" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                    <g transform="matrix(1,0,0,1,0,0)">
                                        <g id="Layer_x0020_1">
                                            <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                            <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#ffffff" stroke="none" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <form onSubmit={onBulkUpload}>
                        <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Show Order</label>
                                <input type="text" className="form-control" id="showOrder" name="showOrder" placeholder="Show Order" value={imageFormData.showOrder} onChange={handleFileChange} />
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="file" className="mb-1">Upload Bulk Images(Max : 6){projectNo === 'GAILEE' && (`(640*960)`) }</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="file"
                                    name="file"
                                    multiple
                                    onChange={handleFileChange}
                                />
                            </div>
                            <div className="submit_btn mt-2">
                                <button type="submit" className="">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {alignImageData === 'Horizontal' ? (
                <div className="row images">
                    {productImageByProductId && productImageByProductId.length > 0 ?
                        productImageByProductId.map((item, i) => (
                            <React.Fragment key={i}>
                                <div className="col-xl-2 col-md-3 col-sm-4 col-6 mt-3" style={{ position: 'relative' }}>
                                    <div className="update_data_icon">
                                        <span onClick={() => isHeaderProductImageById(item?.productImageId)}>
                                            {item.isHeader ? (
                                                <svg fill="#ffffff" height="20" viewBox="0 0 12 12" width="20" xmlns="http://www.w3.org/2000/svg">
                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                        <path d="M0 9h5v2H3v1h6v-1H7v-2h5V0H0z" fill="#ffffff" stroke="none" />
                                                    </g>
                                                </svg>
                                            ) : (
                                                <svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                        <path d="M19 0H1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h5v2h-1c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1h-1v-2h5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-7 18h-4v-2h4zm6-4H2V4h16z" fill="#ffffff" />
                                                        <path d="M7.3 10.7c.4.4 1 .4 1.4 0l1.3-1.3 1.3 1.3c.4.4 1 .4 1.4 0s.4-1 0-1.4l-1.3-1.3 1.3-1.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1.3 1.3-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.3 1.3-1.3 1.3c-.4.4-.4 1 0 1.4z" fill="#ffffff" />
                                                    </g>
                                                </svg>
                                            )}
                                        </span>

                                        <span onClick={() => isDisplayProductImageById(item?.productImageId)}>
                                            {item.isDisplay ? (
                                                <svg fill="#ffffff" height="20" viewBox="0 0 12 12" width="20" xmlns="http://www.w3.org/2000/svg">
                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                        <path d="M0 9h5v2H3v1h6v-1H7v-2h5V0H0z" fill="#ffffff" stroke="none" />
                                                    </g>
                                                </svg>
                                            ) : (
                                                <svg viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                                    <g transform="matrix(1,0,0,1,0,0)">
                                                        <path d="M19 0H1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h5v2h-1c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1h-1v-2h5c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-7 18h-4v-2h4zm6-4H2V4h16z" fill="#ffffff" />
                                                        <path d="M7.3 10.7c.4.4 1 .4 1.4 0l1.3-1.3 1.3 1.3c.4.4 1 .4 1.4 0s.4-1 0-1.4l-1.3-1.3 1.3-1.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1.3 1.3-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.3 1.3-1.3 1.3c-.4.4-.4 1 0 1.4z" fill="#ffffff" />
                                                    </g>
                                                </svg>
                                            )}
                                        </span>
                                        <span title="Edit" onClick={() => onImageEdit(item)}>
                                            <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" width="18" height="18" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnssvgjs="http://svgjs.dev/svgjs"
                                            >
                                                <g transform="matrix(1,0,0,1,0,0)">
                                                    <g transform="translate(-2108 -328)">
                                                        <path
                                                            d="M2144 328h-21c-3.98 0-7.79 1.58-10.61 4.393-2.81 2.813-4.39 6.629-4.39 10.607v34c0 3.978 1.58 7.794 4.39 10.607 2.82 2.813 6.63 4.393 10.61 4.393h26c3.98 0 7.79-1.58 10.61-4.393 2.81-2.813 4.39-6.629 4.39-10.607v-13c0-1.656-1.34-3-3-3s-3 1.344-3 3v13c0 2.387-.95 4.676-2.64 6.364-1.68 1.688-3.97 2.636-6.36 2.636-7.87 0-18.13 0-26 0-2.39 0-4.68-.948-6.36-2.636-1.69-1.688-2.64-3.977-2.64-6.364 0-9.956 0-24.044 0-34 0-2.387.95-4.676 2.64-6.364 1.68-1.688 3.97-2.636 6.36-2.636h21c1.66 0 3-1.344 3-3s-1.34-3-3-3zm9.12 2.636l-30.24 30.243c-.46.459-.76 1.054-.85 1.697l-2 14c-.13.935.18 1.878.85 2.545.67.668 1.61.982 2.54.849l14-2c.65-.092 1.24-.39 1.7-.849 0 0 19.21-19.212 30.24-30.242 1.69-1.688 2.64-3.977 2.64-6.364s-.95-4.676-2.64-6.364c-1.14-1.141-2.37-2.374-3.51-3.515-1.69-1.688-3.98-2.636-6.36-2.636-2.39 0-4.68.948-6.37 2.636zm-4.12 12.607 7.76 7.757-21.17 21.172s-9.05 1.292-9.05 1.292 1.29-9.05 1.29-9.05zm-.88 12.878 3-3c1.17-1.17 1.17-3.072 0-4.242-1.17-1.171-3.07-1.171-4.24 0l-3 3c-1.17 1.17-1.17 3.072 0 4.242 1.17 1.171 3.07 1.171 4.24 0zm12.88-9.364-7.76-7.757 4.12-4.121c.57-.563 1.33-.879 2.13-.879.79 0 1.55.316 2.12.879l3.51 3.514c.56.563.88 1.326.88 2.122 0 .795-.32 1.558-.88 2.121z"
                                                            fill="#ffffff"
                                                            stroke="none"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                        <span title="Delete" onClick={() => productImageDelete(item)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                                <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#ffffff"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    <img className="w-100 h-100" src={`${imageurl}${item?.imgPath}`} alt="" style={{ borderRadius: "12px" }} />
                                </div>
                            </React.Fragment>
                        )) :
                        null
                    }
                </div>
            ) : alignImageData === 'Vertical' ? (
                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={productImageByProductId || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                        paginationPerPage={10}
                    />
                </div>
            ) : null}

            <div className="show_image_align">
                <span className="horizontal" onClick={() => toggleAlignImage('Vertical')}>
                    <img src="../images/horizantalLine.png" alt="Vertical" />
                </span>
                <span onClick={() => toggleAlignImage('Horizontal')}>
                    <img src="../images/gallary.png" alt="Horizontal" />
                </span>
            </div>


            <div id="entryformContainer" className={`adminform entryform ${isImageFormopen ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={onCloseImageForm} >
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <div className="text-center form-heading">
                        <h4>Add Product Image</h4>
                    </div>
                    <form onSubmit={handleImageSubmit}>
                        <div className="form-group">
                            <label htmlFor="productSelect">Product Name</label>
                            <select id="productSelect" name="productId" className="form-control" value={imageFormData.productId} onChange={handleImageChange} required>
                                <option value="">Select a Product</option>
                                {productDetailByIdData?.map((category) => (
                                    <option key={category?.productId} value={category?.productId}>
                                        {category?.displayName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="formFile">File{`(640*960)`}</label>
                            <input type="file" className="form-control" id="file" name="file" accept="image/png, image/jpeg" onChange={handleImageChange} ref={fileInputRef} />
                        </div>
                        <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isHeader" name="isHeader" checked={imageFormData.isHeader} onChange={handleImageChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isHeader</label>
                        </div>
                        <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isDisplay" name="isDisplay" checked={imageFormData.isDisplay} onChange={handleImageChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isDisplay</label>
                        </div>
                        <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isActive" name="isActive" checked={imageFormData.isActive} onChange={handleImageChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isActive</label>
                        </div>
                        <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                            <div className="submit-btn pt-2">
                                <button type="submit">{productImageId ? 'Update' : 'Submit'}</button>
                            </div>
                            <div className="reset-btn pt-2">
                                <button type="button" className="" onClick={onReset}>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SingleProductImages;